// extracted by mini-css-extract-plugin
module.exports = {"hiddenBadge":"TwoDCamerasBadge_hiddenBadge__2c2a5"};